import { useState } from 'react';

export const useSidebar = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [content, setContent] = useState(null);

  const openSidebar = (component) => {
    setContent(component);
    setIsOpen(true);
  };

  const closeSidebar = () => {
    setIsOpen(false);
    setContent(null);
  };

  return {
    isOpen,
    content,
    openSidebar,
    closeSidebar,
  };
};
